var $c79883901739457d$exports = {};
$c79883901739457d$exports = {
    "replaceMessage": `Slipp filen for \xe5 erstatte`
};


export {$c79883901739457d$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
